import React from 'react';

/* tslint:disable */
const SvgIconWhatsapp = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 72 72' {...props}>
    <path d='M36 6a29.65 29.65 0 0 0-25.13 45.46l.7 1.12-3 10.94 11.23-3 1.08.65A29.61 29.61 0 0 0 36 65.36c16.34 0 30-13.3 30-29.65a29.79 29.79 0 0 0-9-21A29.4 29.4 0 0 0 36 6zm17.44 42.42c-.74 2.09-4.3 4-6 4.23-2.83.43-5 .2-10.69-2.23C27.81 46.55 22 37.55 21.51 37s-3.64-4.84-3.64-9.23A10 10 0 0 1 21 20.3a3.26 3.26 0 0 1 2.39-1.13h1.71c.52 0 1.28-.2 2 1.53s2.52 6.17 2.75 6.62a1.57 1.57 0 0 1 .06 1.55c-1.71 3.42-3.53 3.29-2.61 4.86 3.45 5.92 6.89 8 12.13 10.6.9.45 1.42.38 1.94-.23s2.22-2.61 2.81-3.48 1.19-.75 2-.45 5.2 2.45 6.1 2.9 1.48.67 1.71 1a8 8 0 0 1-.55 4.35zM36 71.37A35.72 35.72 0 0 1 18.92 67L0 72l5.06-18.5a35.68 35.68 0 0 1 56.16-43A35.86 35.86 0 0 1 72 35.71c0 19.66-16.36 35.66-36 35.66z' />
  </svg>
);
/* tslint:enable */

export default SvgIconWhatsapp;

